export default 'accidents';
